module.exports = __webpack_public_path__ + "img/26_bronco.0128fc5a.png";